import { mainnet } from 'wagmi/chains';
import { createConfig } from 'wagmi';
import { createWeb3Modal } from '@web3modal/wagmi/react';
import { walletConnect, injected } from 'wagmi/connectors';
import { http, fallback } from 'wagmi';
import { ETHEREUM_CONFIG } from './config';

const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || '';

// 检查 Project ID
if (!projectId) {
  console.error('WalletConnect Project ID 未配置');
}

console.log('WalletConnect Project ID:', projectId);

// 注入式钱包（MetaMask 等）
const injectedConnector = injected({
  target: 'metaMask',
});

// 桌面端 WalletConnect（显示二维码）
const walletConnectDesktop = walletConnect({
  projectId,
  showQrModal: true,
  qrModalOptions: {
    themeMode: 'light',
    enableExplorer: true,
    explorerRecommendedWalletIds: [
      'f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46b2dd',
      'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
      '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
    ]
  }
});

// 移动端 WalletConnect（关闭二维码，走深链）
const walletConnectMobile = walletConnect({
  projectId,
  showQrModal: false,
  qrModalOptions: {
    themeMode: 'light',
    enableExplorer: true,
    explorerRecommendedWalletIds: [
      'f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46b2dd',
      'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
      '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
    ]
  }
});

// 构建优先级 RPC 列表
const rpcUrls = [
  ETHEREUM_CONFIG.rpcUrl,
  ETHEREUM_CONFIG.rpcUrl2,
  ETHEREUM_CONFIG.rpcUrl3,
  'https://eth-mainnet.public.blastapi.io',
  'https://1rpc.io/eth',
  'https://ethereum.publicnode.com',
  'https://rpc.flashbots.net',
  'https://eth.llamarpc.com',
  'https://eth.drpc.org',
].filter(Boolean as unknown as (v: string) => v is string);

console.log('已配置的RPC节点(优先级顺序):');
rpcUrls.forEach((url, i) => console.log(`${i + 1}. ${url}`));

const config = createConfig({
  chains: [mainnet],
  transports: {
    [mainnet.id]: fallback(
      rpcUrls.map(url => http(url)),
      {
        rank: false,
        retryCount: 2,
        retryDelay: 1000,
        timeout: 8000,
      }
    ),
  },
  syncConnectedChain: true,
  connectors: [
    injectedConnector,
    walletConnectDesktop,
    walletConnectMobile,
  ],
});


// 添加调试信息
console.log('Wagmi Config:', {
  chains: config.chains,
  connectors: config.connectors.map(c => ({
    name: c.name,
    id: c.id,
    type: c.type
  }))
});

// 创建 Web3Modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  themeMode: 'light',
  enableAnalytics: false,
  enableOnramp: false,
  defaultChain: mainnet,
  featuredWalletIds: [
    'f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46b2dd',
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
  ]
});

// 导出配置
export default config;